<template>
  <v-card shaped elevation="5" class="notfound">
    <v-card-text>
      <p class="justify display-3 font-weight-medium">
        Sorry, page not found...
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {};
</script>

<style scoped>
.notfound {
  max-width: 500px;
  top: 100px;
  margin: auto;
  text-align: center;
}
</style>
